import { Environment } from "../app/shared/data/models/environment.model";

export const environmentProd: Environment = {
  production: true,
  apiUrl: 'https://web-api.howdy.care/api',
  s3BaseUrl: 'https://howdy-web-app.s3.eu-west-1.amazonaws.com/',
  host: 'app.howdy.care',
  ssoUrl: 'https://sso.howdy.care',
  raygunApiKey: 'zrOyVDspQgzzjdAet4cw'
};
